import request from '@/plugin/axios'

export function singleHouseholdPresetPower (data) { // 单户预置电量
  return request({
    url: '/v1/electricity/presetEleRecord/singleHouseholdPresetPower',
    method: 'post',
    data
  })
}
export function updateRechargeOrderById (data) { // 允许房间绑定
  return request({
    url: '/v1/electricity/webStatsanalysisOrder/updateRechargeOrderById',
    method: 'put',
    data
  })
}

export function findRechargeOrderByParams (params) { // PresetRecord
  return request({
    url: '/v1/electricity/webStatsanalysisOrder/findRechargeOrderByParams',
    method: 'get',
    params
  })
}
